import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { selectItems } from '../../TaxCouponSelectors'
import { actions } from '../../TaxCouponState'
import TaxCouponDirectShelf from './components/TaxCouponDirectGondola/TaxCouponDirectGondola'
import TaxCouponEntryForm from './components/TaxCouponEntryForm'
import TaxCouponItemForm from './components/TaxCouponItemForm'
import TaxCouponSearchModal from './components/TaxCouponSearchModal'
import TaxCouponTable from './components/TaxCouponTable'
import * as S from './TaxCouponEntryPage.styles'

export default () => {
  const items = useSelector(selectItems)
  const dispatch = useDispatch()
  const history = useHistory()
  const handleFinishClick = () => dispatch(actions.sendTaxCouponEntry(history))
  const [enabledButtonFinish, setEnabledButtonFinish] = React.useState(false)

  useEffect(() => () => {
    dispatch(actions.clearTaxCouponData())
  }, [dispatch])

  return (
    <>
      <h1>Entrada de cupom fiscal</h1>
      <p>Digite as informações do cupom fiscal para iniciar entrada</p>
      <TaxCouponEntryForm />
      <hr />
      <TaxCouponItemForm setEnabledButtonFinish={setEnabledButtonFinish} />
      <TaxCouponTable />
      <TaxCouponSearchModal />

      <S.ButtonContainer>
        <TaxCouponDirectShelf setEnabledButtonFinish={setEnabledButtonFinish} />
        <S.FinishButton
          disabled={items.length === 0 || enabledButtonFinish === false}
          title='Finalizar entrada de cupom'
          onClick={handleFinishClick}
          type='submit'
          bgColor='confirm'
          hoverColor='confirmHover'
          letterColor='white'
        />
      </S.ButtonContainer>
    </>
  )
}
